(function () {
  'use strict';

  function initFilterPills() {
    const bar        = document.getElementById('filter-pill-bar');
    const dropdown   = document.getElementById('filter-dropdown');
    const inner      = document.getElementById('filter-dropdown-inner');
    const dataStore  = document.querySelector('.filter-dropdown__data');

    if (!bar || !dropdown || !inner || !dataStore) return;

    const pillBtns = bar.querySelectorAll('.filter-pill--group');

    let activeGroup = null;

    // ── Open / close a filter group ───────────────────────────
    function openGroup(label) {
      const panel = dataStore.querySelector('[data-filter-panel="' + label + '"]');
      if (!panel) return;

      inner.innerHTML = panel.innerHTML;
      dropdown.removeAttribute('hidden');
      activeGroup = label;

      pillBtns.forEach(function (btn) {
        const isThis = btn.dataset.filterGroup === label;
        btn.setAttribute('aria-expanded', isThis ? 'true' : 'false');
      });
    }

    function closeDropdown() {
      dropdown.setAttribute('hidden', '');
      inner.innerHTML = '';
      activeGroup = null;
      pillBtns.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    // ── Pill button clicks ─────────────────────────────────────
    pillBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        const label = btn.dataset.filterGroup;

        if (activeGroup === label) {
          closeDropdown();
        } else {
          openGroup(label);
        }
      });
    });

    // ── Close on outside click ─────────────────────────────────
    document.addEventListener('click', function (e) {
      if (!bar.contains(e.target)) {
        closeDropdown();
      }
    });

    // ── Close on Escape ────────────────────────────────────────
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDropdown();
    });

    // ── Intercept filter option clicks for AJAX (optional) ────
    // If Symmetry has ajax filtering, filter links will reload via ajax automatically.
    // This just closes the dropdown after a selection.
    inner.addEventListener('click', function (e) {
      const link = e.target.closest('.fdd-option');
      if (link) {
        // Small delay so the page/ajax has time to react
        setTimeout(closeDropdown, 80);
      }
    });
  }

  // ── Re-init after Shopify ajax filter updates ─────────────
  // Symmetry fires this event after ajax filtering
  document.addEventListener('theme:section:load', initFilterPills);
  document.addEventListener('cc:ajaxfilter:complete', initFilterPills);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterPills);
  } else {
    initFilterPills();
  }

})();